module.exports = __webpack_public_path__ + "img/features.a7fecb8e.jpg";